import { render } from "./TfaWhatsappOptin.vue?vue&type=template&id=4803dd7a&scoped=true"
import script from "./TfaWhatsappOptin.vue?vue&type=script&lang=js"
export * from "./TfaWhatsappOptin.vue?vue&type=script&lang=js"

import "./TfaWhatsappOptin.vue?vue&type=style&index=0&id=4803dd7a&scoped=true&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4803dd7a"],['__file',"src/views/TwoFaLogin/TfaWhatsappOptin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4803dd7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4803dd7a', __exports__)) {
    console.log('reload')
    api.reload('4803dd7a', __exports__)
  }
  
  module.hot.accept("./TfaWhatsappOptin.vue?vue&type=template&id=4803dd7a&scoped=true", () => {
    console.log('re-render')
    api.rerender('4803dd7a', render)
  })

}


export default __exports__